"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBadge = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../common");
var models_1 = require("../../models");
var GKIcon_1 = __importDefault(require("../GKIcon"));
/**
 * Simple component to provide some additional contextual information, such as a counter
 */
var GKBadge = function (_a) {
    var children = _a.children, color = _a.color, icon = _a.icon, passthroughs = __rest(_a, ["children", "color", "icon"]);
    var isNamedColor = (0, models_1.isBootstrapColor)(color);
    return (React.createElement(reactstrap_1.Badge, __assign({}, (0, common_1.mapDefaultProps)(passthroughs, {
        _gkComponentName: "gk-badge",
        style: !isNamedColor ? { backgroundColor: color } : undefined,
    }), { color: isNamedColor ? color : undefined }),
        icon && React.createElement(GKIcon_1.default, { name: icon }),
        children));
};
exports.GKBadge = GKBadge;
